import { r2 } from "@/lib/format";
/** Taux de taxes de vente du Québec (TPS 5 %, TVQ 9,975 %) + helpers d'arrondi au cent. */
export const TPS_RATE = 0.05;
export const TVQ_RATE = 0.09975;
export const COMBINED_RATE = TPS_RATE + TVQ_RATE;

export { r2 };

/** Taxes sur un montant avant taxes. */
export const taxesOn = (subtotal) => ({ tps: r2(subtotal * TPS_RATE), tvq: r2(subtotal * TVQ_RATE) });

